import { STORAGE_KEYS } from '@/utils/constants.js';

// Identifiant de visiteur anonyme (UUID v4), persisté dans le localStorage.
// Sert UNIQUEMENT à dédupliquer les vues (mesure d'audience) : pas de profilage,
// pas de recoupement, pas de partage. Stable par appareil → survit à la rotation
// d'IP et distingue deux appareils sur un même Wi-Fi (cas typique en bar/fan zone).
//
// Retourne null si le storage est indisponible (navigation privée / storage bloqué) :
// le back retombe alors sur le fingerprint IP+UA (comportement historique).
export const getVisitorId = () => {
    try {
        let vid = localStorage.getItem(STORAGE_KEYS.VISITOR_ID);
        if (!vid) {
            vid = crypto.randomUUID();
            localStorage.setItem(STORAGE_KEYS.VISITOR_ID, vid);
        }
        return vid;
    } catch {
        // Storage bloqué (navigation privée) ou crypto indisponible (contexte non sécurisé)
        // → on renvoie null, le back retombe sur le fingerprint IP+UA.
        return null;
    }
};
